import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface SessionExpiredDialogProps {
  /** Whether the interstitial is shown (driven by the session-expired signal). */
  open: boolean;
  /** Re-initiates authentication (MSAL `loginRedirect`). */
  onSignIn: () => void;
}

/**
 * Re-auth interstitial (A4 case 3). A non-dismissible modal shown over the
 * dimmed shell when a token could not be silently renewed. Deliberately has no
 * `onClose`: the only way out is to sign in again, so the user can't dismiss it
 * back into a dead session.
 */
export function SessionExpiredDialog({ open, onSignIn }: SessionExpiredDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-desc"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="session-expired-title">{t('sessionExpired.title')}</DialogTitle>
      <DialogContent>
        <Typography id="session-expired-desc" variant="body1" sx={{ color: 'text.secondary' }}>
          {t('sessionExpired.body')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={onSignIn}>
          {t('sessionExpired.action')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
